export enum ActionTypeEnum {
  related = 1,
  unrelated = 2
}

export enum RecordSceneEnum {
  sales = 5,
}

